import {
  Facebook,
  Home,
  Instagram,
  Linkedin,
  LogIn,
  LogOut,
  Mail,
  Menu,
  Newspaper,
  Phone,
  PhoneCall,
  ShoppingBag,
  Truck,
  Twitter,
  User,
  Video,
  X,
  Youtube,
} from 'lucide-react';
import { useState } from 'react';
import logo from '../../assets/brand/logo1.png';
import './OffcanvasMenu.css';

const OffcanvasMenu = ({ user = null, setUser, cartCount = 0 }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleNavLinkClick = () => setShow(false);

  const menuLinks = [
    { to: '/', label: 'Home', icon: <Home size={16} /> },
    { to: '/shop/', label: 'Shop', icon: <ShoppingBag size={16} /> },
    { to: '/blogs/', label: 'Blog', icon: <Newspaper size={16} /> },
    { to: '/contact/', label: 'Contact', icon: <Phone size={16} /> },
    { to: '/videos/', label: 'Videos', icon: <Video size={16} /> },
  ];

  const socialLinks = [
    {
      href: 'https://www.facebook.com/bakumia.pk',
      icon: <Facebook size={20} />,
      label: 'Facebook',
    },
    {
      href: 'https://www.instagram.com/bakumia.pk/',
      icon: <Instagram size={20} />,
      label: 'Instagram',
    },
    {
      href: 'https://twitter.com/BakumiaP',
      icon: <Twitter size={20} />,
      label: 'Twitter',
    },
    {
      href: 'https://www.youtube.com/channel/UClgC42QRT6uQFLofuy1We4g',
      icon: <Youtube size={20} />,
      label: 'YouTube',
    },
    {
      href: 'https://www.linkedin.com/company/bakumia/',
      icon: <Linkedin size={20} />,
      label: 'LinkedIn',
    },
  ];

  return (
    <>
      <button
        className="pro-menu-trigger d-lg-none"
        type="button"
        onClick={handleShow}
      >
        <Menu size={26} className="icon" />
      </button>

      {show && (
        <>
          <div className="pro-offcanvas-backdrop" onClick={handleClose} />
          <div className="pro-offcanvas">
            {/* Enhanced Header */}
            <div className="pro-header">
              <a href="/" onClick={handleClose} className="pro-logo">
                <img
                  src={logo}
                  alt="Logo"
                  className="img-fluid"
                  style={{ maxWidth: '130px' }}
                />
              </a>
              <button
                onClick={handleClose}
                className="pro-close-btn"
                type="button"
              >
                <X size={20} className="text-dark" />
              </button>
            </div>

            {/* Enhanced Navigation */}
            <nav className="pro-nav">
              <ul className="pro-nav-list">
                {menuLinks.map((link, i) => (
                  <li key={i} className="pro-nav-item">
                    <a
                      href={link.to}
                      onClick={handleNavLinkClick}
                      className="pro-nav-link"
                    >
                      <span className="pro-nav-icon">{link.icon}</span>
                      {link.label}
                    </a>
                  </li>
                ))}

                <div className="pro-divider"></div>

                {user ? (
                  <>
                    <li className="pro-nav-item">
                      <a
                        href="/account/profile/"
                        onClick={handleNavLinkClick}
                        className="pro-nav-link"
                      >
                        <User size={16} className="pro-nav-icon" />
                        My Account
                      </a>
                    </li>
                    <li className="pro-nav-item">
                      <a
                        href="/account/logout/"
                        onClick={handleNavLinkClick}
                        className="pro-nav-link"
                      >
                        <LogOut size={16} className="pro-nav-icon" />
                        Logout
                      </a>
                    </li>
                  </>
                ) : (
                  <li className="pro-nav-item">
                    <a
                      href="/login/"
                      onClick={handleNavLinkClick}
                      className="pro-nav-link"
                    >
                      <LogIn size={16} className="pro-nav-icon" />
                      Login
                    </a>
                  </li>
                )}
              </ul>
            </nav>

            {/* Enhanced Social Section */}
            <div className="pro-social-section">
              <div className="pro-social-title">Follow Us</div>
              <div className="pro-social-links">
                {socialLinks.map((social, i) => (
                  <a
                    key={i}
                    href={social.href}
                    target="_blank"
                    rel="noreferrer"
                    className="pro-social-link"
                    title={social.label}
                  >
                    <span>{social.icon}</span>
                  </a>
                ))}
              </div>

              {/* Enhanced Contact Info */}
              <div className="pro-contact-info">
                <div className="pro-contact-item">
                  <span className="pro-contact-icon">
                    <PhoneCall size={18} />
                  </span>
                  <a href="tel:03459403395" className="pro-contact-link">
                    +92 345 9403395
                  </a>
                </div>
                <div className="pro-contact-item">
                  <span className="pro-contact-icon">
                    <Mail size={18} />
                  </span>
                  <a
                    href="mailto:support@bakumia.com"
                    className="pro-contact-link"
                  >
                    support@bakumia.com
                  </a>
                </div>
                <div className="pro-shipping-notice">
                  Free Shipping for all Orders above RS 3000
                  <Truck size={18} className="me-2" />
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default OffcanvasMenu;
